import { useState } from "react";
import Header from "components/atoms/Header";
import RecursiveContent from "components/organisms/RecursiveContent";
import Domino from "components/molecules/Domino";
import Story from "components/molecules/Story";
import Syllables from "components/molecules/Syllables";
import QuizImage from "components/molecules/QuizImage";
import EyeOpened from "assets/svg/eye-opened.svg";
import EyeClosed from "assets/svg/eye-closed.svg";
import { splitBySyllables } from "utils/Language/LanguageAnalysis";

import "./styles.scss";

const Card = ({
  lessonId,
  card,
  thisCardIndex,
  cardAddress,
  style,
  baseUrl,
  cunningMode,
  toggleCunningMode,
}) => {
  const cunningModeImage = cunningMode ? EyeClosed : EyeOpened;
  const cunningModeCaption = cunningMode
    ? "Вимкнути «Хитрун-режим»"
    : "Увімкнути «Хитрун-режим»";
  const shouldRenderSound = thisCardIndex === cardAddress?.cardId - 1;
  const [demoItemsRevealed, setDemoItemsRevealed] = useState(1);

  let isDemoFullyUncovered =
  card?.word && demoItemsRevealed >= splitBySyllables(card?.word)?.length * 2;
  const handleClickOnCard = (e) => {
    card?.type === "demo" && setDemoItemsRevealed(demoItemsRevealed + 1);
  };

  return (
    <div
      className="lesson-container"
      data-demo-fully-uncovered={isDemoFullyUncovered}
      style={style}
      onClick={handleClickOnCard}
    >
      <div className={"card-container " + card?.type}>
        {card?.type === "info-page" && (
          <div className="wrapper">
            <div className="article">
              <RecursiveContent
                content={card?.streamlinedArticle?.content}
                card={card}
                baseUrl={baseUrl}
              />
            </div>
          </div>
        )}
        {card?.type === "story" && <Story card={card} baseUrl={baseUrl} />}
        {card?.type !== "info-page" && card?.type !== "story" && (
          <div className="wrapper">
            <Header
              lessonNumber={lessonId}
              type={card?.type}
              baseUrl={baseUrl}
            />
            {card?.type === "read-and-point" ||
            card?.type === "key-read-and-point" ? (
              <div>
                <img
                  src={cunningModeImage}
                  className="cunning-mode-button"
                  alt={cunningModeCaption}
                  title={cunningModeCaption}
                  onClick={() => {
                    toggleCunningMode();
                  }}
                />
                {card?.type === "key-read-and-point" ? (
                  <Domino
                    syllables={card?.keys}
                    size="md"
                    keysCunningMode={cunningMode}
                  />
                ) : null}
              </div>
            ) : null}
            {card?.type === "syllables" ? (
              <Domino
                syllables={card?.syllables}
                size="lg"
                shouldRenderSound={shouldRenderSound}
              />
            ) : null}
            {card?.type.indexOf("read") >= 0 || card?.type === "demo" ? (
              <>
                <Syllables
                  word={card?.word}
                  type={card?.type}
                  demoItemsRevealed={demoItemsRevealed}
                />
              </>
            ) : null}
            {card?.type.indexOf("point") >= 0 ? (
              <QuizImage
                word={card?.word}
                exceptions={card?.exceptions}
                next={(id) => card?.next(card?.id)}
                quizCunningMode={cunningMode}
              />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
